export default "__VITE_ASSET__BIGMgbJQ__"